'use strict';

const index = require('./index-4474431a.js');

const campaignTypeNames = {
  VPR: "Similar Products",
  VPS: "Visual Search",
  VCS: "Cross-Selling",
  TPS: "Text Product Search",
};
const isVPR = (c) => c._tag === "VPR";
function fold(onVPR, onVCS) {
  return (c) => (isVPR(c) ? onVPR() : onVCS());
}
function fromString(s) {
  return s === "VPR" ? { _tag: "VPR" } : { _tag: "VCS" };
}

const vprSlotsNames = [
  "vviinn-recommendations-title",
  "vviinn-recommendations-subtitle",
  "vviinn-update-button-text",
  "vviinn-update-button-icon",
  "vviinn-basket-button-text",
  "vviinn-basket-button-icon",
  "vviinn-basket-button-text-pressed",
  "vviinn-basket-button-icon-pressed",
  "vviinn-favorite-icon",
  "vviinn-favorite-icon-pressed",
];
const vpsSlotsNames = [
  "vviinn-teaser-text",
  "vviinn-image-upload-button-text",
  "vviinn-image-upload-icon",
  "vviinn-camera-button-text-start",
  "vviinn-camera-button-text-stop",
  "vviinn-camera-icon",
  "vviinn-text-search-icon",
  "vviinn-privacy-badge-text",
  "vviinn-image-search-modal-title",
];
const filtersSlotsNames = [
  "vviinn-extended-filters-title",
  "vviinn-extended-filters-apply",
  "vviinn-extended-filters-reset",
];
const productCardSlotsNames = ["vviinn-energy-label-data-sheet-text"];
const renderNamedSlot = (name) => index.h("slot", { name: name });
const SlotSkeleton = (renderType) => {
  return (renderType === "vps"
    ? [...vpsSlotsNames, ...filtersSlotsNames, ...productCardSlotsNames]
    : renderType === "filters"
      ? filtersSlotsNames
      : [...vprSlotsNames, ...filtersSlotsNames, ...productCardSlotsNames]).map(renderNamedSlot);
};
const getSlots = (element) => Array.from(element.shadowRoot.querySelectorAll("slot"));
const getNameAttribute = (element) => element.getAttribute("name");
const getSlotAttribute = (element) => element.getAttribute("slot");
const elementContainSlot = (slot) => (container) => {
  const name1 = getNameAttribute(slot);
  const name2 = getSlotAttribute(container);
  return name1 === name2;
};
const getContentToReplace = (targets) => (acc, content) => {
  const replaceCandidate = targets.find(elementContainSlot(content));
  if (replaceCandidate) {
    acc.set(content, replaceCandidate);
  }
  return acc;
};
const replaceSlotContent = (content, target) => {
  target.innerHTML = content.outerHTML;
};
const castAsHtmlElement = (element) => element;
const getShadowRoots = (shadowRoot) => {
  const levelOne = shadowRoot;
  const levelTwo = levelOne && castAsHtmlElement(levelOne.lastChild).shadowRoot;
  const levelThree = levelTwo && castAsHtmlElement(levelTwo.lastChild).shadowRoot;
  return { levelOne, levelTwo, levelThree };
};
const slotChangeListener = (component, element) => {
  component.connectedCallback = function () {
    document.addEventListener("globalSlotsChanged", ({ detail }) => {
      const elementTagName = element.tagName;
      const isElementChildTag = [
        "VVIINN-PRODUCT-CARD",
        "VVIINN-TEASER",
        "VVIINN-EXAMPLE-IMAGE",
        "VVIINN-PRIVACY-BADGE",
        "VVIINN-MODAL",
        "VVIINN-TEXT-SEARCH",
        "VVIINN-EXTENDED-FILTERS",
      ].includes(elementTagName);
      const productCardChildrenTags = ["VVIINN-ENERGY-LABEL"];
      const elementsAreDifferent = element !== detail.element;
      const elementsAreDifferentAndNotChildTag = elementsAreDifferent && !isElementChildTag;
      const isSearchButtonTag = detail.element.tagName === "VVIINN-VPS-BUTTON" &&
        elementTagName === "VVIINN-VPS-WIDGET";
      const detailElementShadowRoot = detail.element.shadowRoot;
      const { levelOne: detailLevelOneShadowRoot, levelTwo: detailLevelTwoShadowRoot, levelThree: detailLevelThreeShadowRoot, } = getShadowRoots(detailElementShadowRoot);
      const elementIsNotChildOfDetailElement = !(detailLevelOneShadowRoot &&
        detailLevelOneShadowRoot.contains(element)) &&
        !(detailLevelTwoShadowRoot &&
          detailLevelTwoShadowRoot.contains(element)) &&
        !(detailLevelThreeShadowRoot &&
          detailLevelThreeShadowRoot.contains(element));
      const elementIsChildTagButNotChildOfDetailElement = isElementChildTag && elementIsNotChildOfDetailElement;
      const isNotChildOfCurrentDetailElement = (elementsAreDifferentAndNotChildTag ||
        elementIsChildTagButNotChildOfDetailElement) &&
        !isSearchButtonTag;
      const isNotChildOfCurrentSearchButton = isSearchButtonTag && !detailElementShadowRoot.contains(element);
      const elementIsNotRelatedToCurrentDetailElement = isNotChildOfCurrentDetailElement || isNotChildOfCurrentSearchButton;
      const elementIsNotChildOfProductCard = !productCardChildrenTags.includes(elementTagName);
      if (elementsAreDifferent &&
        elementIsNotRelatedToCurrentDetailElement &&
        elementIsNotChildOfProductCard) {
        return;
      }
      const slotsToReplace = getSlots(element).reduce(getContentToReplace(detail.slots), new Map());
      slotsToReplace.forEach(replaceSlotContent);
    }, true);
  };
  component.connectedCallback.call(component);
};

const version = "2.122.0";

exports.SlotSkeleton = SlotSkeleton;
exports.campaignTypeNames = campaignTypeNames;
exports.fold = fold;
exports.fromString = fromString;
exports.slotChangeListener = slotChangeListener;
exports.version = version;
